export const ROUTE_PATHS = {
  NOT_FOUND: '*',
  DASHBOARD: '/',
  ACCOUNTS: 'accounts',
  ACCOUNT_ITEM: 'accounts/:uuid',
  CONTACTS: 'contacts',
  CONTACT_ITEM: 'contacts/:uuid',
  EMPLOYEES: 'employees',
  SCHEDULING: 'scheduling',
  EMPLOYEE_ITEM: 'employees/:uuid',
  EVENTS: 'events',
  EVENTS_CALENDAR: 'events/calendar',
  EVENTS_TABLE: 'events/table',
  EVENT_ITEM: 'events/:uuid',
  TASKS: 'tasks',
  TASK_ITEM: 'tasks/:uuid',
  USER_SETTINGS: 'user-settings',
  PREFERENCES: 'preferences',
  ORGANIZATION: 'organization',
  INTEGRATIONS: 'integrations',
  USER_ROLES: 'user-roles',
  UER_ROLE_ITEM: 'user-roles/:uuid',
  OAUTH_REDIRECT_GOOGLE: 'oauth2redirect-google',
  OAUTH_CALLBACK_GOOGLE: 'oauth2callback-google',
  OAUTH_REDIRECT_OUTLOOK: 'oauth2redirect-outlook',
  OAUTH_CALLBACK_OUTLOOK: 'oauth2callback-outlook',
  EVENT_TEMPLATES: 'event-templates',
  EVENT_TEMPLATE_ITEM: 'event-templates/:uuid',
  TASK_TEMPLATES: 'task-templates',
  TASK_TEMPLATE_ITEM: 'task-templates/:uuid',
  EMAIL_TEMPLATES: 'email-templates',
  EMAIL_TEMPLATE_ITEM: 'email-templates/:uuid',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:uuid',
  SIGN_UP: '/sign-up/:uuid',
  LOGIN: '/login',
  CREATE_ACCOUNT: '/create-account',
};
